/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_PsychodieteticsInputs */

const en_service_type_psychodietetics = /** @type {(inputs: Service_Type_PsychodieteticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Psychodietetics`)
};

const pl_service_type_psychodietetics = /** @type {(inputs: Service_Type_PsychodieteticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Psychodietetyka`)
};

/**
* | output |
* | --- |
* | "Psychodietetics" |
*
* @param {Service_Type_PsychodieteticsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_psychodietetics = /** @type {((inputs?: Service_Type_PsychodieteticsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_PsychodieteticsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_psychodietetics(inputs)
	return en_service_type_psychodietetics(inputs)
});